import React from 'react'
import { GetStaticProps } from 'next'

import { Settings } from '@ecm/config/Settings'
import { runEff } from '@ecm/effect'
import BlogList, { BlogListProps } from '@ecm/ui/component/blog/BlogList'

export const ArticleDefaultImageUrl = '/images/generic-blog-post-feature-image.jpg'

export const BlogHomePage = ({
  articles,
  categories,
  categorySlug = 'all',
  currentPage,
  totalPages,
}: BlogListProps) => (
  <BlogList
    articles={articles}
    categories={categories}
    categorySlug={categorySlug}
    currentPage={currentPage}
    totalPages={totalPages}
    pageSlug="blog"
  />
)

export default BlogHomePage

export const getStaticProps: GetStaticProps = async () => {
  const categories = await runEff(async eff => {
    try {
      return eff.getCategories()
    } catch (e) {
      return []
    }
  })

  const paginatedArticles = await runEff(async eff => {
    try {
      return await eff.getPaginatedArticles(1)
    } catch (e) {
      return null
    }
  })
  if (!paginatedArticles) {
    return {
      props: {
        articles: [],
        totalPages: 0,
      },
    }
  }

  const totalPages = Math.ceil(paginatedArticles.total / Settings.pagination.pageSize)

  return {
    props: {
      articles: paginatedArticles.items,
      categories,
      currentPage: 1,
      totalPages: totalPages,
    },
  }
}
